import http from '@/utils/http';
const base_path = '/v2/tool/buttonTitle';

/**
 * 获取按钮文案接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getButtonTitleApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
